<template>
  <div class="pm-dialog-progress">
    <div class="flex justify-center dialog-content" style="padding:1rem;">
      <div @mousedown="selectedId = String(master.id)" class="vs-col" v-for="(master,index) in masterList" :key="index" style="margin:0.2rem;">
        <vs-chip
          :color="(String(selectedId) === String(master.id)) ? colorList.find(color => String(color.id) === String(master.id)).value : null "
          class="pm-input-key"
        >
          {{ master.value }}
        </vs-chip>
      </div>
    </div>
    <div class="flex justify-center">
      <div style="font-size:large;padding:1rem;" >現在時刻  {{ nowStr }}</div>
    </div>


    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
        v-shortkey="{save: ['enter'], saveWithUpdateTime: ['shift', 'enter']}" @shortkey="callKeyActions"
      >
        保存
      </vs-button>
      <vs-button
        v-if="!isImportEditMode && !isInsertOneMode"
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
// Editでは修正
// const { mapActions, mapState, mapGetters } = createNamespacedHelpers("portMasterDestinationWork");
const { mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");

import moment from "moment-timezone";

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
    isImportEditMode: { type: Boolean,  default: false },
    isInsertOneMode:  { type: Boolean,  default: false },
  },
  data() {
    return {
      selectedId: null,
      now: null,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      return this.masterMap['progress'];
    },
    enableSave() {
      return true; // ( this.selectedId );
    },
    colorList() {
      return this.masterMap['progress_colors'];
    },
    nowStr() {
      return moment(this.now).local().format("HH:mm");
    },
  },
  methods: {
    initData() {
      this.selectedId = this.valueMap ? this.valueMap.id : -1 ;
      this.now = moment().valueOf();
    },
    callKeyActions(event) {
      switch (event.srcKey) {
      case 'save':
        if (this.enableSave) this.onSubmit(false, true)
        break
      case 'saveWithUpdateTime':
        if (this.enableSave) this.onSubmit(true, true)
        break
      }
    },
    onSubmit(isUpdateTimeStamp, toNextColumn = false) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      if (toNextColumn) mode.push("toNextColumn")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey] = String(this.selectedId);
      updateKeyValueMap["progress_at"] = {};
      if (this.selectedId != "1") {
        updateKeyValueMap["progress_at"][this.selectedId] = new Date(moment(this.now).local().format("YYYY/MM/DD HH:mm"));
      }
      this.$emit('updateValue', this.taskId, updateKeyValueMap, mode, this.columnKey);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
#dialog-user-search-input-form {
  ul li {
    display: inline;
  }
  .input-user-name {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
  }
}
.pm-dialog-progress {
  .dialog-content {
    flex-wrap: wrap;
  }
  .con-vs-chip {
    border-radius:5px;
    height:3rem;
    width: 8rem;
    font-size: 120%;
  }
  .pm-input-key {
    background-color: $pm-paper-white;
    border: 1px solid $pm-gray;
    color: $pm-black;
    cursor: pointer;
  }
  .save-button {
    margin: 1rem !important;
    width: 30%;
  }
}

</style>

